import { mgrPledgeModalCollectGatewayCreditApply } from './pledge-pay-open-payment-gateway';
import { collectPledgePaymentRows } from './pledge-pay-rows';
import { getCsrfToken, getPaymentMode } from './pledge-pay-utils';

function buildRecurringPaymentPayloadFields($root) {
    return {
        frequency_id: $root.find('select[name="frequency"] option:selected').attr('id'),
        duration: $root.find('#pledge_payment_duration').val(),
        run_today: $root.find('input[name="run_today"]').is(':checked') ? '1' : '0',
        pledge_start_date: $root.find('input[name="pledge_start_date"]').val(),
        pledge_installment_amount: $root.find('input[name="installment_amount"]').val(),
        surcharge_installment_amount: $root.find('input[name="surcharge_installment_amount"]').val(),
        process_type: 'token',
    };
}

function buildOpenPaymentPayloadFields($root) {
    return {
        open_credit_apply_by_gateway: mgrPledgeModalCollectGatewayCreditApply($root),
    };
}

function appendRecurringFieldsIfNeeded($root, payload) {
    if (getPaymentMode($root) === 'recurring') {
        Object.assign(payload, buildRecurringPaymentPayloadFields($root));
    }
    return payload;
}

function buildPledgePaymentPayload($root, variant, overrides = {}) {
    const rows = collectPledgePaymentRows($root);
    const payload = {
        cover_surcharge: $root.find('#cover_surcharge').prop('checked'),
        _token: overrides.csrfToken ?? getCsrfToken(),
        ...buildOpenPaymentPayloadFields($root),
    };

    if (variant === 'manager') {
        payload.pledges = rows;
        payload.user_id = $root.find('#payment_user_id').val();
    } else {
        payload.selected_pledges = rows;
        if ($root.find('#donor_comments').length) {
            payload.donor_comments = $root.find('#donor_comments').val() || '';
        }
    }

    return appendRecurringFieldsIfNeeded($root, payload);
}

function buildManagerPledgePaymentPayload($root, overrides = {}) {
    return buildPledgePaymentPayload($root, 'manager', overrides);
}

function buildQrPledgePaymentPayload($root, overrides = {}) {
    return buildPledgePaymentPayload($root, 'qr', overrides);
}

export {
    buildManagerPledgePaymentPayload,
    buildQrPledgePaymentPayload,
};
